import React, { FC } from 'react'
import styled from 'styled-components'

interface Prop {
  open: boolean
  // eslint-disable-next-line no-unused-vars
  setOpen: (value: boolean) => void
}

/*
 * Defined at module scope, not inside the component: styled-components builds a
 * fresh class on every render otherwise, which remounts the node and throws
 * away the line transitions.
 *
 * It also sits in normal flow now. It used to be `position: absolute` with a
 * percentage `top`, which resolved against the sticky header wrapper and so
 * drifted whenever the announcement bar or navbar changed height.
 */
const StyledBurger = styled.button<{ open: boolean }>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 5px;
  /* 44px keeps the tap target at the accessible minimum even though the
     lines themselves are 24px wide. */
  width: 44px;
  height: 44px;
  padding: 0 6px;
  background: transparent;
  border: none;
  cursor: pointer;

  &:focus-visible {
    outline: 3px solid #990000;
    outline-offset: 2px;
    border-radius: 4px;
  }

  .hamburger-line {
    width: 100%;
    height: 3px;
    background: ${(props) => props.theme.colors.black};
    border-radius: 10px;
    transition: transform 0.3s ease, opacity 0.2s ease;
  }

  .hamburger-line.one {
    transform: ${(props) =>
      props.open ? 'translateY(8px) rotate(45deg)' : 'none'};
  }

  .hamburger-line.two {
    opacity: ${(props) => (props.open ? 0 : 1)};
  }

  .hamburger-line.three {
    transform: ${(props) =>
      props.open ? 'translateY(-8px) rotate(-45deg)' : 'none'};
  }
`

const Hamburger: FC<Prop> = ({ open, setOpen }) => (
  <StyledBurger
    open={open}
    onClick={() => setOpen(!open)}
    aria-label={open ? 'Close navigation menu' : 'Open navigation menu'}
    aria-expanded={open}
    aria-controls="mobile-menu"
  >
    <span className="hamburger-line one" aria-hidden="true" />
    <span className="hamburger-line two" aria-hidden="true" />
    <span className="hamburger-line three" aria-hidden="true" />
  </StyledBurger>
)

export default Hamburger
